// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayKeyValue_container__3KqV3","value":"DisplayKeyValue_value__241tp","itemFirst":"DisplayKeyValue_itemFirst__2aVKm"};